import React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import {
  setIsTaskModalOpen,
  setTaskSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import DebounceSearchField from 'src/components/shared/debounceSearchField/debounceSearchField';

/**
 * Default component
 */
const TopOptions = () => {
  const dispatch = useAppDispatch();
  const { taskSearchFieldValue } = useAppSelector((state) => state.taskConfigPage);

  return (
    <Row widths={['92.5%', '7.5%']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width="grid-4">
        <DebounceSearchField
          value={taskSearchFieldValue}
          onDebounce={(v) => dispatch(setTaskSearchFieldValue(v))}
          placeholder="Search for..."
        />
      </Row>
      <Button className="view-and-edit-tasks__open-modal" onClick={() => dispatch(setIsTaskModalOpen(true))}>
        Add Task
      </Button>
    </Row>
  );
};

// **** Export **** //

export default TopOptions;
